import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface BreadcrumbContextType {
  dynamicLabels: Record<string, string>;
  setDynamicLabel: (path: string, label: string) => void;
  clearDynamicLabel: (path: string) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [dynamicLabels, setDynamicLabels] = useState<Record<string, string>>({});

  const setDynamicLabel = useCallback((path: string, label: string) => {
    setDynamicLabels((prev) => ({ ...prev, [path]: label }));
  }, []);

  const clearDynamicLabel = useCallback((path: string) => {
    setDynamicLabels((prev) => {
      const updated = { ...prev };
      delete updated[path];
      return updated;
    });
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ dynamicLabels, setDynamicLabel, clearDynamicLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
  }
  return context;
};
